import React from "react";
import {Colors, Text} from "@bounce/shared/ui";

export const FieldLabel = ({children}: {children: string}) => (
  <Text size={13} sx={{color: Colors.grey._700, mb: 0.5}}>
    {children}
  </Text>
);

export const mutedButtonSx = {
  borderColor: Colors.tertiary._300,
  color: Colors.grey._800,
  "&:hover": {borderColor: Colors.tertiary._400, backgroundColor: Colors.grey._100},
};

export const linkButtonSx = {
  border: 0,
  background: "transparent",
  p: 0,
  fontFamily: "inherit",
  fontSize: 12,
  fontWeight: 600,
  color: Colors.blue._800,
  cursor: "pointer",
} as const;
